import Vue from 'vue'
import _ from 'lodash'
import axios from 'axios'
import t from '../../translation'
import VueCookies from 'vue-cookie'
import store from '../../store'   // ← ajout important

// var nlbURL = function () {
//     // le nlb retourn la bonne url du nodejs
//   return {'url': 'i-0a4293bee837ae2e0-N4-1A-nodejs-prod.watcheebox.net/'}
// }

// Vue.use(VueSocketio, socketio(nlbURL().url)) // connexion au socket.io distribué par le NLB

const watcheebox = {
  vue: new Vue(),
  // ---------------------------------------------------------------------------------
  // Connexion d'un agent au nodejs de chat
  // ---------------------------------------------------------------------------------
  connexionAgent: (data) => {
    console.log('connexionAgent : ', VueCookies.get('PHPSESSID'))
    // IMPORTANT : encodage des accents avant envois au serveur de chat
    var datasAgent = _.cloneDeep(data.datasAgent)
    // console.log('cookies session php', VueCookies.get('PHPSESSID'))
    let phpSession = VueCookies.get('PHPSESSID') ? VueCookies.get('PHPSESSID').slice(0, 10) : ''
    // 🔥 Correction : utilisation du store importé
    store.commit('_StoreWatcheeBox/SET_SESSION_PHP', phpSession)
    // datasAgent.licAllKeys = datasAgent.licAllKeys.join('|')
    datasAgent.licAllKeys = Array.isArray(datasAgent.licAllKeys) ? datasAgent.licAllKeys.join('|') : ''
    // console.log('datasAgent', datasAgent)
    if (!datasAgent.status) {
      datasAgent.status = 'online' // 'online' par defaut pour les reconnexion apres multisession
    }
    new Vue().$socket.emit('addAgent', {
      'roomName': datasAgent.entKey,
      'agentConversation': 0,
      'agentEtat': datasAgent.status,
      'agentConnexionMobile': 0,
      'agentDevice': 0,
      'agentName': data.agentName,
      'agentID': datasAgent.id,
      'geteLang': datasAgent.licLang,
      'agentJob': datasAgent.job,
      'agentAvatar': datasAgent.avatar,
      'WZAgentId': datasAgent.id,
      'entrepriseId': datasAgent.entId,
      'listLicKeysForThisAgent': datasAgent.licAllKeys,
      'listOpened': '',
      'tokenFB': datasAgent.facebookToken,
      'nameAppFB': datasAgent.facebookPage,
      'whatsappTel': datasAgent.whatsappTel,
      'whatsappSid': datasAgent.whatsappSid,
      'whatsappToken': datasAgent.whatsappToken,
      'serviceSid': datasAgent.serviceSid,
      'priority': datasAgent.priority,
      'keywords': datasAgent.keywords,
      'user_sites': datasAgent.user_sites,
      'sessionPHP': phpSession,
      'sid': datasAgent.licenceId,
      'keyWebPush': JSON.parse(data.keyWebPush),
      'subscriptionWebPush': JSON.parse(data.subscriptionWebPush),
      'agentPhone': datasAgent.phone,
      'agentIOS': datasAgent.ios,
      'urlConf': datasAgent.urlConf // url conf apizee
    })
  },

  // ---------------------------------------------------------------------------------
  // ajoute un chatBot
  // ---------------------------------------------------------------------------------
  addChatBot: (data) => {
    console.log('addChatBot : ', data)
    // IMPORTANT : encodage des accents avant envois au serveur de chat
    var datasAgent = _.cloneDeep(data.datasAgent)
    var user = _.cloneDeep(data.user)
    // // console.log('datasAgent phone', datasAgent.phone)
    // let phpSession = data.sessionPHP ? data.sessionPHP.slice(0, 10) : ''
    // // datasAgent.licAllKeys = datasAgent.licAllKeys.join('|')
    let licAllKeys = Array.isArray(user.licAllKeys) ? user.licAllKeys.join('|') : ''
    // console.log('datasAgent', datasAgent)
    // if (!datasAgent.status) {
    //   datasAgent.status = 'online' // 'online' par defaut pour les reconnexion apres multisession
    // }
    new Vue().$socket.emit('addChatBot', {
      'roomName': user.entKey,
      'agentConversation': 0,
      'agentEtat': 'online',
      'agentConnexionMobile': 0,
      'agentDevice': 0,
      'agentName': datasAgent.USR_FIRST_NAME + ' ' + datasAgent.USR_LAST_NAME,
      'agentID': datasAgent.USR_ID,
      'geteLang': user.licLang,
      'agentJob': datasAgent.USR_JOB ? datasAgent.USR_JOB : '',
      'agentAvatar': datasAgent.USR_ID + '_avatar.jpg',
      'WZAgentId': datasAgent.USR_ID,
      'entrepriseId': user.entId,
      'listLicKeysForThisAgent': licAllKeys,
      'listOpened': '',
      'tokenFB': '',
      'nameAppFB': '',
      'whatsappTel': '',
      'whatsappSid': '',
      'whatsappToken': '',
      'serviceSid': '',
      'priority': '',
      'keywords': '',
      'user_sites': '',
      'sessionPHP': '',
      'sid': user.licenceId,
      'keyWebPush': '',
      'subscriptionWebPush': '',
      'agentPhone': '',
      'agentIOS': '',
      'urlConf': '' // url conf apizee
    })
  },

  // -------------------------------------------------------------------
  // Affichage du contenu de l'historique de chat du visiteur
  // -------------------------------------------------------------------
  // loadHistoChatVisiteur: function (socket, agentSocket, infoAgent, chatSession) {
  //   // demande l'affichage de l'historique de cette conversation
  //   new Vue().$socket.emit('historique-conversation', {
  //     'agentSocketID': agentSocket,
  //     'chatSession': chatSession,
  //     'agentID': infoAgent.id,
  //     'siteId': infoAgent.entId, // a remplace par un evariable du store
  //     'entrepriseId': infoAgent.entId, // a remplace par un evariable du store
  //     'mUrl': infoAgent.multiSite // c'etait mUrl comme variable ici
  //   })
  // },

  // -------------------------------------------------------------------
  // Demande l'historique de chat du visiteur
  // -------------------------------------------------------------------
  firstLoadHistoChat: function (data) {
    console.log('firstLoadHistoChat', data)
    let histoChat
    return new Promise((resolve, reject) => {
      // Demande l'historique de chat au serveur nodejs
      axios.get('get/histoChat.php?entrepriseID=' + data.entrepriseId + '&chatSession=' + data.chatSession + '&chatMax=30')
      .then(response => {
        if (!_.isNil(response.data) && _.isArray(response.data)) {
          histoChat = response.data.reverse()

          var optionsDate = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}
          var premiereDate = new Date() // par defaut maintenant
          if (histoChat.length !== 0) {
            premiereDate = new Date(histoChat[0].timestamp * 1000) // sinon la date du premier chat
          }
          var dateReference = premiereDate.toLocaleDateString(t.locale, optionsDate)
          // ajoute la date de debut du chat
          if (histoChat.length > 0) {
            var firstDate = {
              'dateMessage': true,
              'visitorId': histoChat[0].visitorId,
              'timeStamp': dateReference,
              'indexMessage': 0
            }
            histoChat.splice(0, 0, firstDate) // ajoute la premiere date en haute du tableau
          }
          for (var i = 0; i < histoChat.length; i++) {
            if (histoChat[i].type === '1') {
              // recherche la date du message
              // et l'affiché si c'est le premier de la journée
              var dateNow = new Date(histoChat[i].timestamp * 1000)
              if (dateReference !== dateNow.toLocaleDateString(t.locale, optionsDate)) {
                // la date de reference change
                dateReference = dateNow.toLocaleDateString(t.locale, optionsDate)
                var newDate = {
                  'dateMessage': true,
                  'dateId': histoChat[i].visitorId + '_' + i,
                  'timeStamp': dateReference,
                  'indexMessage': i
                }
                histoChat.splice(i, 0, newDate) // ajoute la premiere date en haute du tableau
              }
            }
          }
          resolve(histoChat)
        }
        resolve([])
      })
      .catch(e => {
        reject(e)
      })
    })
  },

  // -------------------------------------------------------------------
  // Force l'ouverture du module chez le client
  // -------------------------------------------------------------------
  forceOuvertureModule: function (data) {
    if (data.datasVisiteur.socketID && data.datasVisiteur.socketID.length) {
      new Vue().$socket.emit('forceAppear', {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'agentSocketID': data.agentSocketID,
        'clientSocketID': data.datasVisiteur.socketID,
        'chatSession': data.datasVisiteur.visiteurID,
        'WZAgentId': data.datasAgent.id,
        'siteId': data.datasVisiteur.siteID,
        'entrepriseId': data.datasAgent.entId
      })
    }
  },

  // -------------------------------------------------------------------
  // Envois d'une action webcall
  // actions :
  // -------------------------------------------------------------------
  actionsWebcall: function (data) {
    console.log('--> action webcall', data)
    new Vue().$socket.emit('WebCallActions', {
      'action': data.action,
      'auteur': 'Agent',
      'nameAuteur': data.agentName,
      'mySocketID': data.agentSocketID,
      'cibleSocketID': data.sessionWebcall.visiteurSocketID,
      'chatSession': data.sessionWebcall.sessionId,
      'WZAgentId': data.datasAgent.id,
      'siteId': data.sessionWebcall.siteId,
      'entrepriseId': data.datasAgent.entId,
      'timestamp': Date.now(),
      'entrepriseKey': data.datasAgent.entKey
    })
  },

  // -------------------------------------------------------------------
  // Envois d'un message chat vers facebook
  // -------------------------------------------------------------------
  envoisFacebook: function (data) {
    // console.log('--> un message pour facebook')
    // efface le retour à la ligne
    data.message = data.message.replace(/\n/g, '')
    new Vue().$socket.emit('sendChatMessenger', {
      'auteur': 'Agent',
      'nameAuteur': data.agentName,
      'message': data.message,
      'attachments': data.attachments,
      'clientMessengerID': data.datasVisiteur.visiteurID,
      'chatSession': data.datasVisiteur.visiteurID,
      'WZAgentId': data.datasAgent.id,
      'messageType': data.messageType,
      'nameVisiteur': data.datasVisiteur.nameVisiteur,
      'tokenMessenger': data.datasAgent.facebookToken
    })
  },

  // -------------------------------------------------------------------
  // Envois d'un message chat vers whatsapp
  // version twilio
  // -------------------------------------------------------------------
  envoisWhatsapp: function (data) {
    console.log('--> un message pour whatsapp')
    // efface le retour à la ligne
    data.message = data.message.replace(/\n/g, '')
    new Vue().$socket.emit('sendChatWhatsapp', {
      'auteur': 'Agent',
      'nameAuteur': data.agentName,
      'message': data.message,
      'attachments': data.attachments,
      'To': 'whatsapp:+' + data.datasVisiteur.visiteurID,
      'From': 'whatsapp:' + data.datasAgent.whatsappTel,
      'chatSession': data.datasVisiteur.visiteurID,
      'WZAgentId': data.datasAgent.id,
      'messageType': data.messageType,
      'nameVisiteur': data.datasVisiteur.nameVisiteur,
      'whatsappSid': data.datasAgent.whatsappSid,
      'whatsappToken': data.datasAgent.whatsappToken,
      'timeStamp': Math.floor(Date.now() / 1000),
      'siteId': data.datasVisiteur.siteID,
      'entrepriseId': data.datasAgent.entId
    })
  },

  // -------------------------------------------------------------------
  // Envois d'un message chat vers whatsapp
  // version facebook api
  // -------------------------------------------------------------------
  // envoisWhatsapp: function (data) {
  //   console.log('--> un message pour whatsapp')
  //   // efface le retour à la ligne
  //   data.message = data.message.replace(/\n/g, '')
  //   new Vue().$socket.emit('sendChatWhatsapp', {
  //     'auteur': 'Agent',
  //     'nameAuteur': data.agentName,
  //     'message': data.message,
  //     'attachments': data.attachments,
  //     'To': data.datasVisiteur.visiteurID,
  //     'From': data.datasAgent.whatsappTel,
  //     'chatSession': data.datasVisiteur.visiteurID,
  //     'WZAgentId': data.datasAgent.id,
  //     'messageType': data.messageType,
  //     'nameVisiteur': data.datasVisiteur.nameVisiteur,
  //     'whatsappSid': data.datasAgent.whatsappSid,
  //     'whatsappToken': data.datasAgent.whatsappToken,
  //     'timeStamp': Math.floor(Date.now() / 1000),
  //     'siteId': data.datasVisiteur.siteID,
  //     'entrepriseId': data.datasAgent.entId
  //   })
  // },

  // -------------------------------------------------------------------
  // Sauvegarde les data webPush
  // -------------------------------------------------------------------
  saveDataWebPush: function (data) {
    // console.log('save web push', data)
    new Vue().$socket.emit('saveTokenWebPush', data)
  },

  // -------------------------------------------------------------------
  // Envois d'un webPush
  // -------------------------------------------------------------------
  sendWebPush: function (data) {
    console.log('send web push', data)
    new Vue().$socket.emit('sendWebPush', data)
  },

  // -------------------------------------------------------------------
  // Envois d'un message chat
  // -------------------------------------------------------------------
  // type 1 : message normal (envoyer par un agent ou un visiteur)
  // type 2 : message automatique (envoyer par un agent en fonction du filtre activé)
  // type 3 : message push
  // type 4 : formulaire de satisfaction
  // type 5 : formulaire lead
  // type 7 : message system
  // type 999 : banned
  envoisMessage: function (data) {
    // efface le retour à la ligne
    data.message = data.message.replace(/\n/g, '')
    console.log('data.message', data.message)
    console.log('envoisMessage', data)
    // si il y a un socketID au visiteur c'est qu'il est bien connecté au serveur
    if (data.datasVisiteur.socketID && data.datasVisiteur.socketID.length) {
      console.log('le visiteur est encore la : ', data.datasVisiteur.socketID)
      // à chaque envois de message, il faut stoper le istyping qui c'est declenché
      // enois un stop "istyping" au serveur
      new Vue().$socket.emit('stop-typing-targetFirst', {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'senderSocketID': data.agentSocketID,
        'cibleSocketID': data.datasVisiteur.socketID,
        'etat': 0
      })
// ne pas envoyer de type 2 ni 3 si le mode filtrage FO est act
      // envois du message au serveur nodejs
      new Vue().$socket.emit('sendChat-targetFirst', {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'message': data.message,
        'attachments': data.attachments,
        'agentSocketID': data.agentSocketID,
        'clientSocketID': data.datasVisiteur.socketID,
        'chatSession': data.datasVisiteur.visiteurID,
        'WZAgentId': data.datasAgent.id,
        'messageType': data.messageType,
        'siteId': data.datasVisiteur.siteID,
        'entrepriseId': data.datasAgent.entId,
        'entrepriseKey': data.datasAgent.entKey,
        'filterId': data.filterId,
        'nameVisiteur': data.datasVisiteur.visiteurID, // j'ai mis l'id du visiteur, mais cela devrait etre son nom  si identifié
        'read': '1' // le message est lu car il y a un socketId pour le visiteur
      })

    // sinon le visiteur n'est plus connecté, il faut lui envoyer le message en absence
    } else {
      console.log('le visiteur est plus la : ', data.datasVisiteur.socketI)
      if (data.messageType === 1) {
        // envois du message en absence au serveur nodejs
        new Vue().$socket.emit('sendChat-targetFirst',
          {
            'auteur': 'Agent',
            'nameAuteur': data.agentName,
            'message': data.message,
            'attachments': data.attachments,
            'agentSocketID': data.agentSocketID,
            'clientSocketID': data.datasVisiteur.socketID,
            'chatSession': data.datasVisiteur.visiteurID,
            'WZAgentId': data.datasAgent.id,
            'messageType': data.messageType,
            'siteId': data.datasVisiteur.siteID,
            'entrepriseId': data.datasAgent.entId,
            'entrepriseKey': data.datasAgent.entKey,
            'filterId': data.filterId,
            'nameVisiteur': data.datasVisiteur.visiteurID, // j'ai mis l'id du visiteur, mais cela devrait etre son nom  si identifié
            'read': '0'
          }
        )
      }
    }
  },

  // ----------------------------------------------------------------------
  // Start le istyping
  // ----------------------------------------------------------------------
  startIsTyping: function (data) {
    new Vue().$socket.emit('start-typing-targetFirst',
      {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'senderSocketID': data.agentSocketID,
        'cibleSocketID': data.datasVisiteur.socketID,
        'WZAgentId': data.datasAgent.id,
        'chatSession': data.datasVisiteur.visiteurID,
        'etat': 1
      }
    )
  },

  // ----------------------------------------------------------------------
  // Stop le istyping
  // ----------------------------------------------------------------------
  stopIsTyping: function (data) {
    new Vue().$socket.emit('stop-typing-targetFirst',
      {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'senderSocketID': data.agentSocketID,
        'cibleSocketID': data.datasVisiteur.socketID,
        'WZAgentId': data.datasAgent.id,
        'chatSession': data.datasVisiteur.visiteurID,
        'etat': 0
      }
    )
  },

  // ----------------------------------------------------------------------
  // envoi le formulaire de satisfaction au visiteur
  // apres le fermeteur du chat dans le pupitre
  // ----------------------------------------------------------------------
  sendFormSatisfaction: function (data) {
    new Vue().$socket.emit('sendFormSatisfaction',
      {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'message': 'Would you like to evaluate our performance? ',
        'agentSocketID': data.agentSocketID,
        'clientSocketID': data.datasVisiteur.socketID,
        'chatSession': data.datasVisiteur.visiteurID,
        'WZAgentId': data.datasAgent.id,
        'messageType': data.messageType,
        'siteId': data.datasVisiteur.siteID,
        'entrepriseId': data.datasAgent.entId
      }
    )
  },

  // ----------------------------------------------------------------------------
  // Actions de transfere de chat vers un autre agent dispo
  // ----------------------------------------------------------------------------
  SendTransfertVisitor (data) {
    // console.log('SendTransfertVisitor', data)
    var agentSelect // les données agent
    // recherche le bon agent
    for (var a = 0; a < data.agentsArray.length; a++) {
      if (data.agentsArray[a][2] === data.selectedAgent.id) {
        agentSelect = data.agentsArray[a]
      }
    }
    var msg = data.agentSenderName + ' vous propose de prendre en charge ce visiteur (' + data.datasSelectedVisiteur.visiteurID + ') ?'
    this.transfertDatasVisitor({
      'socket': data.socket,
      'agentSocketID': agentSelect[4],
      'datasAgent': agentSelect,
      'datasVisiteur': data.datasSelectedVisiteur,
      'message': msg,
      'messageType': 1,
      'senderSocketID': data.mySocketID,
      'senderAgentID': data.myAgentID,
      'automatique': data.automatique
    })
  },

  // ----------------------------------------------------------------------
  // transfere de chat
  // l'agent envois un chat à un autre agent
  // ----------------------------------------------------------------------
  transfertDatasVisitor: function (data) {
    new Vue().$socket.emit('transfertVisitor',
      {
        'auteur': 'Agent',
        'agentName': data.datasAgent[1],
        'msg': data.message,
        'destAgentSocket': data.agentSocketID, // c'est le socketID de l'agent qui receptionne
        'clientSocketID': data.senderSocketID, // c'est le socketId de l'agent qui envoi le transfere
        'senderID': data.senderAgentID, // c'est l'id de l'agent qui envoi le transfere
        'chatSession': data.datasVisiteur.visiteurID,
        'WZAgentId': data.datasAgent[2],
        'messageType': data.messageType,
        'siteId': data.datasVisiteur.siteID,
        'visKey': data.datasVisiteur.visiteurKey,
        'entrepriseId': data.datasAgent[10],
        'automatique': data.automatique
      }
    )
  },

  // ----------------------------------------------------------------------
  // transfere rejeté
  // l'agent ne veux pas prendre le transfere de chat
  // ----------------------------------------------------------------------
  rejetTransfert: function (data) {
    new Vue().$socket.emit('transfertVisitorRefuse',
      {
        'WZAgentId': data.datasTransfere.WZAgentId,
        'agentSocket': data.datasTransfere.clientSocketID,
        'destAgentSocket': data.datasTransfere.destAgentSocket,
        'chatSession': data.datasTransfere.chatSession
      }
    )
  },

  // ----------------------------------------------------------------------
  // transfere accepté
  // l'agent prendre en charge le transfere de chat
  // ----------------------------------------------------------------------
  acceptTransfert: function (data) {
    new Vue().$socket.emit('transfertVisitorAccept',
      {
        'WZAgentId': data.datasTransfere.WZAgentId,
        'agentSocket': data.datasTransfere.clientSocketID,
        'destAgentSocket': data.datasTransfere.destAgentSocket,
        'chatSession': data.datasTransfere.chatSession
      }
    )
  },

  // ----------------------------------------------------------------------------
  // Annule le transfere de chat vers un autre agent dispo
  // ----------------------------------------------------------------------------
  AnnulTransfertVisitor (data) {
    var msg = data.agentSenderName + ' a annulé la prise en charge du visiteur'
    new Vue().$socket.emit('transfertVisitorAnnuler',
      {
        'senderAgentSocket': data.mySocketID,
        'agentSocket': data.selectedAgent.socketID,
        'message': msg
      }
    )
  },

  // ----------------------------------------------------------------------
  // Change le status de l'agent
  // ----------------------------------------------------------------------
  changeStatusAgent: function (data) {
    console.log('[watcheebox] changeStatusAgent', data)
    new Vue().$socket.emit('changeStatutAgent',
      {
        roomName: data.roomName,
        idAgent: data.agentID,
        statut: data.statut,
        listOpened: data.sessionsPrivees,
        sessionPHP: data.sessionPHP
      }
    )
  },

  // ----------------------------------------------------------------------
  // Focus de l'agent sur le BO
  // ----------------------------------------------------------------------
  changeFocusAgent: function (data) {
    new Vue().$socket.emit('focus-agent',
      {
        'roomName': data.datasAgent.entKey,
        'agentID': data.datasAgent.id,
        'focusAgent': data.focusAgent,
        'focusSessionID': data.focusSessionID
      }
    )
  },

  // ----------------------------------------------------------------------
  // Le client retourne dans la room
  // ----------------------------------------------------------------------
  clientRetourRoom: function (data) {
    let phpSession = data.sessionPHP.slice(0, 10)
    new Vue().$socket.emit('rejoinRoom',
      {
        'roomName': data.datasAgent.entKey,
        'agentID': data.datasAgent.id,
        'sessionPHP': phpSession
      }
    )
  },

  // ----------------------------------------------------------------------
  // Le client ce connect à une room
  // ----------------------------------------------------------------------
  clientConnectRoom: function (data) {
    console.log('clientConnectRoom', data)
    new Vue().$socket.emit('connectRoom',
      {
        'roomName': data.roomName
      }
    )
  },

  // ----------------------------------------------------------------------
  // Le client quitte une room
  // ----------------------------------------------------------------------
  clientQuitRoom: function (data) {
    new Vue().$socket.emit('quitRoom',
      {
        'roomName': data.roomName
      }
    )
  },

  // ----------------------------------------------------------------------
  // Le client quitte une room
  // ----------------------------------------------------------------------
  deconnexionSession: function (data) {
    // console.log('deconnexionSession', data)
    new Vue().$socket.emit('logoutAgent',
      {
        'agentID': data.datasAgent.id
      }
    )
  },

  // ----------------------------------------------------------------------
  // Force la deconnexion du client au socket
  // ----------------------------------------------------------------------
  deconnexionClient: function (data) {
    new Vue().$socket.emit('DeconnexionClient',
      {
        'roomName': data.datasAgent.entKey
      }
    )
  },

  // ----------------------------------------------------------------------
  // Debloque l'agent du mode multisession
  // ----------------------------------------------------------------------
  debloqueSession: function (data) {
    // console.log('debloqueSession')
    new Vue().$socket.emit('DebloqueMultisession',
      {
        'roomName': data.datasAgent.entKey,
        'agentID': data.datasAgent.id
      }
    )
  },

  // ----------------------------------------------------------------------
  // incremente le nombre de conversation avec l'agent
  // ----------------------------------------------------------------------
  totalConversations: function (data) {
    new Vue().$socket.emit('total-conversation',
      {
        'roomName': data.datasAgent.entKey,
        'agentID': data.datasAgent.id,
        'agentSocketID': data.agentSocketID,
        'statut': data.status,
        'chatSession': data.arrayVisiteur.visiteurID,
        'sessionsPrivees': data.sessionsPrivees
      }
    )
  },

  // ----------------------------------------------------------------------
  // Mise à jour des sessions chats de l'agent
  // ----------------------------------------------------------------------
  updateSessionsChats: function (data) {
    new Vue().$socket.emit('update-sessionsChats',
      {
        'roomName': data.datasAgent.entKey,
        'agentID': data.datasAgent.id,
        'sessionsPrivees': data.sessionsPrivees
      }
    )
  },

  // ----------------------------------------------------------------------
  // Accusé de reception du message
  // ----------------------------------------------------------------------
  receptionMessage: function (data) {
    new Vue().$socket.emit('accuseReceptionMessage',
      {
        'visiteurID': data.datasVisiteur.visiteurID,
        'siteID': data.siteID,
        'agentID': data.datasAgent.id,
        'agentSocketID': data.agentSocketID,
        'clientSocketID': data.datasVisiteur.socketID,
        'ARType': data.ARType,
        'messageID': data.messageID
      }
    )
  },

  // ----------------------------------------------------------------------
  // envois une offre de mise en relation pour du webRTC
  // ----------------------------------------------------------------------
  WebRTC_Candidate: function (data) {
    new Vue().$socket.emit('webrtcCandidate',
      {
        'visiteurID': data.datasVisiteur.visiteurID,
        'roomName': 'screensharing_' + data.datasVisiteur.visiteurID,
        'agentID': data.datasAgent.id,
        'answerSocketID': data.agentSocketID,
        'cibleSocketID': data.datasVisiteur.socketID,
        'type': data.type,
        'candidate': data.candidate
      }
    )
  },
  // ----------------------------------------------------------------------
  // envois une offre de mise en relation pour du webRTC
  // ----------------------------------------------------------------------
  WebRTC_Offer: function (data) {
    console.log('WebRTC_Offer', data)
    new Vue().$socket.emit('webrtcOffer',
      {
        'visiteurID': data.datasVisiteur.visiteurID,
        'roomName': 'screensharing_' + data.datasVisiteur.visiteurID,
        'agentID': data.datasAgent.id,
        'answerSocketID': data.agentSocketID,
        'cibleSocketID': data.datasVisiteur.socketID,
        'iceConfiguration': data.iceConfiguration,
        'type': 'video-offer',
        'sdp': data.sdp
      }
    )
  },
  // ----------------------------------------------------------------------
  // envois de la réponse de mise en relation pour du webRTC
  // ----------------------------------------------------------------------
  WebRTC_Answer: function (data) {
    new Vue().$socket.emit('webrtcAnswer',
      {
        'visiteurID': data.datasVisiteur.visiteurID,
        'roomName': 'screensharing_' + data.datasVisiteur.visiteurID,
        'agentID': data.datasAgent.id,
        'answerSocketID': data.answerSocketID,
        'cibleSocketID': data.cibleSocketID,
        'type': 'video-answer',
        'sdp': data.sdp
      }
    )
  },
  // ----------------------------------------------------------------------
  // ferme la connexion peerToPeer en local et chez le client
  // ----------------------------------------------------------------------
  WebRTC_Peer_Close: function (data) {
    new Vue().$socket.emit('webrtcPeerClose',
      {
        'visiteurID': data.datasVisiteur.visiteurID,
        'roomName': 'screensharing_' + data.datasVisiteur.visiteurID,
        'agentID': data.datasAgent.id,
        'answerSocketID': data.answerSocketID,
        'cibleSocketID': data.cibleSocketID,
        'type': 'video-answer',
        'sdp': data.sdp
      }
    )
  },
  // ----------------------------------------------------------------------
  // demande un acces à un turn/stun serveur (test avec twilio)
  // ----------------------------------------------------------------------
  WebRTC_askTurnServeur: function (data) {
    new Vue().$socket.emit('webrtcAskTurnServeur',
      {
        'cibleSocketID': data.askSocketID
      }
    )
  },

  // ----------------------------------------------------------------------
  // Compte le nombre d'elements present dans le node
  // ----------------------------------------------------------------------
  compteElementChat: function (parentWatchBoxMessage) {
    var data = 0
    if (parentWatchBoxMessage) {
      // var parentWatchBoxMessage = document.getElementById('chatSession')
      var nbElement = parentWatchBoxMessage.childNodes[0].childNodes[1]
      // return nbElement.childNodes.length
      // if(parentWatchBoxMessage.getElementByClassName());
      // nb_element_de_class=$(".ma_classe").length;
      var numChild = nbElement.childNodes.length
      var dateVis
      for (var a = 0; a < nbElement.childNodes.length; a++) {
        // je ne compte ni les dates ni les message auto
        if (nbElement.childNodes[a].classList.contains('WZ-MessageAuto') || nbElement.childNodes[a].classList.contains('dates-messages_BO') || nbElement.childNodes[a].classList.contains('dates-messages-2') || nbElement.childNodes[a].classList.contains('dates-marqueur') || nbElement.childNodes[a].classList.contains('statusMessageVisiteur')) {
          numChild--
        }
        if (nbElement.childNodes[a].classList.contains('bulle_Visiteur_BO')) {
          if (nbElement.childNodes[a].childNodes[0].children[1].getAttribute('data-timestamp')) {
            dateVis = nbElement.childNodes[a].childNodes[0].children[1].getAttribute('data-timestamp')
          }
        }
      }
      // retourne le nombre de bulle chat, et la date du dernier message visiteur
      data = {'numChild': numChild, 'dateMessage': dateVis}
      return data
    } else {
      return data // retourne 0
    }
  },

  // ----------------------------------------------------------------------
  // Demande de géolocalisation au serveur
  // ----------------------------------------------------------------------
  demandeGeoloc: function (data) {
    new Vue().$socket.emit('askGeoloc',
      {
        'clientSocketID': data.datasVisiteur.socketID,
        'visiteurID': data.datasVisiteur.visiteurID,
        'agentSocketID': data.mySocketID
      }
    )
  },

  // ----------------------------------------------------------------------
  // CHANGE LE STATUT DE L'AGENT ONLINE/OFFLINE
  // ----------------------------------------------------------------------
  AgentStatut (data) {
  //   var j_listOpenDiscuss = ""
  //   if (statut === "busy" && listOpenedVis.length !== 0){
  //     j_listOpenDiscuss = JSON.stringify(listOpenedVis)
  //   }
  //   socket.emit('changeStatutAgent', {'roomName': roomName, 'idAgent': idAgent, 'statut': statut, 'listOpened': j_listOpenDiscuss})
  //   //change l'apparence du chat actif si l'agent est offline ou online, s'il est busy rien ne change
  //   if (statut === 'offline' || statut === 'online'){
  //     changeChatApparence(statut, sessionPrive) // active ou désactive les chats
  //   }
  //   agentStatut = statut
  },

  // ----------------------------------------------------------------------
  // L'AGENT SE DECONNECT DU BO
  // ----------------------------------------------------------------------
  AgentLogout (data) {
  }

}

export default watcheebox



// WEBPACK FOOTER //
// ./src/components/watcheebox/watcheebox.js